<template>
    <div
        class="flex items-start space-x-4 text-black overflow-visible"
        :class="[isSlider ? 'wall-row' : '']"
    >
        <ReviewCard
            v-for="testimonial in testimonials"
            :key="testimonial.id"
            :wall="wall"
            :testimonial="testimonial"
            class="flex-shrink-0"
            :style="{ width: `${slideWidth}px` }"
        />
    </div>
</template>

<script>
import ReviewCard from "./ReviewCard.vue";
export default {
    name: "SliderRow",
    props: {
        testimonials: Array,
        wall: Object,
        slideWidth: Number,
        isSlider: Boolean,
    },
    components: {
        ReviewCard,
    },
};
</script>
